export default __webpack_public_path__ + "static/media/cost-estimation-basics.c3f0efd5.svg";